import ReactMarkdown from 'react-markdown';
import rehypeSanitize from 'rehype-sanitize';
import remarkGfm from 'remark-gfm';

/**
 * Sanitized Markdown (NFR-01, AC-27): raw HTML is skipped, output is sanitized, links open safely and
 * remote images are never fetched automatically; they render as links instead.
 */
export function Markdown({ children }: { children: string }) {
  return (
    <div className="markdown">
      <ReactMarkdown
        skipHtml
        remarkPlugins={[remarkGfm]}
        rehypePlugins={[rehypeSanitize]}
        components={{
          a: ({ href, children: c }) => (
            <a href={href} target="_blank" rel="noopener noreferrer nofollow">
              {c}
            </a>
          ),
          img: ({ src, alt }) => (
            <span className="blocked-image">
              [Image not loaded automatically: {alt || 'image'} —{' '}
              <a
                href={typeof src === 'string' ? src : '#'}
                target="_blank"
                rel="noopener noreferrer nofollow"
              >
                open
              </a>
              ]
            </span>
          ),
        }}
      >
        {children}
      </ReactMarkdown>
    </div>
  );
}
